import { render } from "./ResearcherDetailPage.vue?vue&type=template&id=7ba1930f"
import script from "./ResearcherDetailPage.vue?vue&type=script&lang=js"
export * from "./ResearcherDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__